import React from 'react'
import './Other.css'

const Other = ({ transporter_data }) => {
    const otherBusinessInterest = transporter_data?.other_business_interest

    return (
        <div className="othercard">
            <div className="othercontainer row">
                <div className="col-12">
                    <h3 className="data_header">Other Business Interest</h3>
                </div>
                <div className="col-12">
                    {otherBusinessInterest ? (
                        <span>{otherBusinessInterest}</span>
                    ) : (
                        <p>Details not available</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Other
